import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

import {
  Box,
  Grid,
  useMediaQuery,
  Typography,
} from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavData } from './data';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
const StyledLink = styled(Link)`
  color: #000;
  &:hover {
    color: white;
  }
`;

const NavLink = ({ to, text }) => (
  <Grid item>
    <Box px="24px">
      <StyledLink
        to={to}
        activeStyle={{
          color: 'white',
        }}
        partial="true"
      >
        <Typography variant="h6" style={{ fontFamily: 'Martel' }}>
          {text}
        </Typography>
      </StyledLink>
    </Box>
  </Grid>
);
const Footer = () => {
  const theme = useTheme();
  const isMobile = !useMediaQuery(theme.breakpoints.up('md'));
  return (
    <Box
      minHeight="20vh"
      px={isMobile ? '24px' : '32px'}
      color={`${theme.palette.text.secondary}`}
      bgcolor={`${theme.palette.secondary.main}`}
      display="flex"
      alignItems="center"
      justifyContent="center"
      marginTop="auto"
    >
      <Grid container alignItems="center" justify="space-between">
        <Grid item xs={6} sm={4} md={4} lg={4} xl={4}>
          <Typography variant="h6">{` © Ichhyashakti, ${new Date().getFullYear()}`}</Typography>
        </Grid>
        <Grid
          item
          xs={6}
          sm={2}
          md={2}
          lg={2}
          ml={2}
          container
          spacing={2}
          justify="flex-end"
        >
          <Grid item>
            <OutboundLink
              href="https://www.facebook.com/Ichhya-112789360393592"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={['fab', 'facebook-square']}
                style={{
                  color: '#fff',
                  fontSize: '40px',
                }}
              />
            </OutboundLink>
          </Grid>
          <Grid item>
            <OutboundLink
              href="https://www.instagram.com/ichhyashakti/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={['fab', 'instagram-square']}
                style={{
                  color: '#fff',
                  fontSize: '40px',
                }}
              />
            </OutboundLink>
          </Grid>
        </Grid>
        {!isMobile && (
          <Grid
            item
            container
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={6}
            direction={isMobile ? 'column' : 'row'}
            alignItems="flex-end"
            justify="flex-end"
          >
            {NavData.map((d, i) => {
              if (d.to.includes('#self-assessment'))
                return (
                  <NavLink
                    key={i}
                    to={'questionnaire'}
                    text={d.text}
                  />
                );
              return <NavLink key={i} to={d.to} text={d.text} />;
            })}
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
export default Footer;
